module.exports = __webpack_public_path__ + "static/media/unloaded_active.daffd8eb.svg";